import React from "react";
import { useSocket } from "common/hooks/useSocket";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "common/components/ConfirmDialog";

type ConfirmLeaveDraftProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

const ConfirmLeaveDraft = (props: ConfirmLeaveDraftProps) => {
  const { open, setOpen } = props;
  const { t } = useTranslation();
  const socket = useSocket();
  const navigate = useNavigate();

  return (
    <ConfirmDialog
      open={open}
      onClose={() => setOpen(false)}
      title={t("Quitter la draft")}
      description={t("Veux-tu quitter la draft ?")}
      onCancel={() => setOpen(false)}
      onConfirm={() => {
        socket.emit("send-leave-room");
        navigate("/");
      }}
      confirmLabel={t("Quitter")}
    />
  );
};

export default ConfirmLeaveDraft;
